import { useQuery } from '@tanstack/react-query'
import { compact, flatten, get, map, pipe, split, trim } from 'lodash/fp'
import { PropsWithChildren } from 'react'

import '@masterplandev/utils'

import { FeatureProvider } from '@/core/utils/features/FeatureProvider'
import isLocalStorageEnabled from '@/core/utils/localStorage/isLocalStorageEnabled'
import { env } from '@/env'
import { usersQueries } from '@/http/api/users'

const commaStringToArray = pipe([split(','), map(trim), compact])

function useFeaturesSources() {
  const configFeatures = commaStringToArray(env.REACT_APP_FEATURES ?? '')
  const devFeatures =
    env.DEV && isLocalStorageEnabled()
      ? commaStringToArray(get('features')(localStorage))
      : []

  const { data: userFeatures } = useQuery({
    ...usersQueries.usersCurrentDetails(),
    select: (data) => data.features ?? [],
    // Fetching is intentionally disabled because FeaturesProvider renders before
    // AuthenticationProvider. User features will be available after authentication.
    enabled: false,
  })
  return pipe([flatten, compact])([userFeatures, devFeatures, configFeatures])
}

export function FeaturesProvider({ children }: PropsWithChildren) {
  const features = useFeaturesSources()

  return <FeatureProvider features={features}>{children}</FeatureProvider>
}
